export const formatTaskStatus = (status) => {
  const value = String(status || "").trim().replace(/[_-]+/g, " ").toLowerCase();
  return value ? `${value.charAt(0).toUpperCase()}${value.slice(1)}` : "";
};
// Older CRM tasks predate the four Operations task statuses.
export const normalizeTaskStatus = (status) => {
  const value = String(status || "new").trim().toLowerCase();
  const legacyStatuses = {
    open: "new",
    "in-progress": "started",
    in_progress: "started",
    complete: "completed",
    done: "completed",
    cancelled: "closed",
    canceled: "closed",
  };
  return legacyStatuses[value] || value;
};
